import { useT } from "../i18n/LanguageProvider";
import { parseFlexibleTime24 } from "../utils/time24";

export interface TimeInput24Props {
  id?: string;
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
  /** When true, blur with empty input clears the value for optional fields. */
  allowEmpty?: boolean;
  className?: string;
  "aria-label"?: string;
}

/**
 * Always-editable 24-hour time (HH:mm). Uses a text field so display does not
 * follow the OS 12h/locale preference like &lt;input type="time"&gt;.
 */
export function TimeInput24({
  id,
  value,
  onChange,
  disabled,
  allowEmpty = false,
  className = "",
  "aria-label": ariaLabel,
}: TimeInput24Props) {
  const { t } = useT();
  const handleBlur = () => {
    if (allowEmpty && !value.trim()) {
      onChange("");
      return;
    }
    const parsed = parseFlexibleTime24(value);
    if (parsed) onChange(parsed);
  };

  return (
    <input
      id={id}
      type="text"
      inputMode="numeric"
      autoComplete="off"
      spellCheck={false}
      placeholder={t("timeInput.placeholder")}
      title={t("timeInput.hint")}
      aria-label={ariaLabel}
      className={`input-time-24 ${className}`.trim()}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onBlur={handleBlur}
      disabled={disabled}
      maxLength={5}
    />
  );
}
